export default {"src":"/_next/static/media/feedback.3ff775c7.svg","height":22,"width":24,"blurWidth":0,"blurHeight":0};